__turbopack_context__.v({
  "list_left": "WithButtonList-module-scss-module__k2T7PG__list_left",
  "list_right": "WithButtonList-module-scss-module__k2T7PG__list_right",
  "list_wrap": "WithButtonList-module-scss-module__k2T7PG__list_wrap",
  "with_button_list_over_text": "WithButtonList-module-scss-module__k2T7PG__with_button_list_over_text",
  "with_button_list_title": "WithButtonList-module-scss-module__k2T7PG__with_button_list_title",
});
